<!-- TODO: add this to Storybook, when its ready to fill with components -->
<template>
  <AtomLink
    v-if="label && !mobileMenusStore.mobileFilterStatus && !mobileMenusStore.overviewHeaderActive"
    :url="url"
    fallback-component="button"
    :class="[backgroundColor, hoverBackgroundColor, computedTextColor, computedHoverTextColor, { 'back-button-position-to-header': !flush }]"
    class="transform transition duration-200 cursor-pointer group shadow-md hover:shadow-none text-sm leading-none font-semibold inline-flex items-center rounded-br-3xl pl-5 pr-8 py-3"
    @click="onClick"
  >
    <AtomIconArrowLeft class="w-3 mr-2" />
    <span>{{ label }}</span>
  </AtomLink>
</template>

<script setup lang="ts">
const props = defineProps({
  label: { type: String, required: true },
  backgroundColor: { type: String, required: false, default: 'bg-app-primary-1-red--fire-brick' },
  hoverBackgroundColor: { type: String, required: false, default: 'hover:bg-black' },
  flush: { type: Boolean, required: false, default: false },
  url: { type: [Object, String], required: false, default: undefined },
  textColor: { type: String, required: false, default: undefined },
  hoverTextColor: { type: String, required: false, default: undefined },
})

const emit = defineEmits(['click'])

const mobileMenusStore = useMobileMenusStore()

function onClick(event: Event) {
  emit('click', event)
}

const computedTextColor = props.textColor ? props.textColor : 'text-white'
const computedHoverTextColor = props.hoverTextColor ? props.hoverTextColor : ''
</script>

<style lang="scss">
// scoped scss is not suitable for this component, it won't work in this case because it needs to inherit styles from parent elements

// This style is set default, to make it appear at the right spot because it is always sitting right underneath the site header,
// but you CAN disable it by setting the flush option to true if you want to use this button on another spot than the header.
.back-button-position-to-header {
  @apply absolute z-10 bottom-0;
  margin-bottom: -38px; // 38px is the height of this button
  /* Don't block the overview search bar that sits beside this control */
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
}
</style>
